export type LoginRedirectParams = {
  returnTo?: string;
  screenHint?: 'signup' | 'login';
  connection?: string;
  organization?: string;
  invitation?: string;
  loginHint?: string;
  prompt?: 'login' | 'none';
  linkToken?: string;
  extra?: Record<string, string>;
};

export const buildLoginUrl = (params: LoginRedirectParams = {}): string => {
  const searchParams = new URLSearchParams();
  if (params.returnTo) searchParams.set('returnTo', params.returnTo);
  if (params.screenHint) searchParams.set('screen_hint', params.screenHint);
  if (params.connection) searchParams.set('connection', params.connection);
  if (params.organization) searchParams.set('organization', params.organization);
  if (params.invitation) searchParams.set('invitation', params.invitation);
  if (params.loginHint) searchParams.set('login_hint', params.loginHint);
  if (params.prompt) searchParams.set('prompt', params.prompt);
  if (params.linkToken) searchParams.set('link_token', params.linkToken);
  if (params.extra) {
    for (const [key, value] of Object.entries(params.extra)) {
      searchParams.set(key, value);
    }
  }
  const query = searchParams.toString();
  return query ? `/auth/login?${query}` : '/auth/login';
};

export const goToLogin = (params?: LoginRedirectParams): void => {
  window.location.href = buildLoginUrl(params);
};

export const goToLogout = (returnTo?: string): void => {
  window.location.href = returnTo
    ? `/auth/logout?returnTo=${encodeURIComponent(returnTo)}`
    : '/auth/logout';
};
